import React from 'react';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../../components';
import FavoritePackage from '../../../components/FavoritePackage/FavoritePackage';
import ShareButton from '../../ListingPage/ShareButton';
import css from '../PackagePage.module.css';
import { TopbarContainer } from '../..';

const PackagePageWrapper = ({
  children,
  currentUser,
  currentListing,
  currentPackage,
  onToggleFavoritePackage,
  followSubjectMutation,
  unfollowSubjectMutation,
  followedSubjects,
  ...rest
}) => {
  return (
    <Page {...rest} nofollow noindex={false}>
      <LayoutSingleColumn className={css.pageRoot}>
        <LayoutWrapperTopbar>
          <TopbarContainer
            customMobileSecondaryActions={
              <div className={css.mobileSecondaryWrapper}>
                {currentListing && (
                  <FavoritePackage
                    currentUser={currentUser}
                    listing={currentListing}
                    package={currentPackage}
                    onFavoritePackage={() =>
                      onToggleFavoritePackage(currentPackage, currentListing)
                    }
                    onUnfavoritePackage={() =>
                      onToggleFavoritePackage(currentPackage, currentListing)
                    }
                    followSubjectMutation={followSubjectMutation}
                    unfollowSubjectMutation={unfollowSubjectMutation}
                    followedSubjects={followedSubjects}
                  />
                )}
                <ShareButton shareDark />
              </div>
            }
          />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>{children}</LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

export default PackagePageWrapper;
